import React from 'react'
import s from '../../css/main/main.module.css'
import PreviewItem from './PreviewItem'
import Loader from '../Loader'
import { Link } from 'react-router-dom'
import { getCleanData, getIsSevenDaysPassed } from '../../helpers/changesHelper'

const Main = ({ previewData }) => {
    return (
        <>
            <div className={s.title}>
                <div className={s.title__body}>
                    <h1>Kinopoisk Api Unofficial</h1>
                    <p>
                        Неофициальное api для доступа к актуальной информации кинопоиска.
                        Более подробную информацию вы можете найти&nbsp;
                        <a
                            href='https://kinopoiskapiunofficial.tech/documentation/api/'
                            target='_blank'
                            tabIndex='8'
                            rel='noreferrer'
                        >
                            тут
                        </a>
                        .
                    </p>
                    <p className={s.notice}>
                        <b>ВАЖНО:</b> В данный момент для всех новых юзеров лимит - 500 запросов в сутки.
                        Если вам нужен расширенный лимит - пишите на <a
                        href='mailto:support@kinopoiskapiunofficial.tech'
                        tabIndex='11'>
                        support@kinopoiskapiunofficial.tech
                    </a>
                    </p>
                </div>
            </div>
            <div className={s.preview}>
                <div className={s.preview__title}>
                    <h3>Последние изменения:</h3>
                    <Link to='/changes' tabIndex='9'>
                        Смотреть все
                    </Link>
                </div>
                <div className={s.preview__body}>
                    <ul>
                        {previewData ? (
                            previewData.map(item => (
                                <PreviewItem
                                    key={item.id}
                                    id={item.id}
                                    title={item.title}
                                    description={item.description}
                                    date={getCleanData(item.creationTime)}
                                    isSevenDaysPassed={getIsSevenDaysPassed(item.creationTime)}
                                />
                            ))
                        ) : (
                            <Loader/>
                        )}
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Main
